export const emailTips = {
  80187: '请填写客户邮箱，一个邮箱只能绑定一家企业',
  80210: '重要提示：填写企业联系人姓名、手机号、身份证号需三者实名认证为同一人！！！',
  80211: '重要提示：填写企业联系人姓名、手机号、身份证号需三者实名认证为同一人！！！',
  80265: '重要提示：填写企业联系人姓名、手机号、身份证号需三者实名认证为同一人！！！',
}

// 80221这类产品，不需要选人员和职业，所有其他责任都只跟随主险联动
export const singleClauseProductMap = {
  80221: {
    mainClauseCode: 'GP8022149746228',
    additionalClause: {
      name: '附加食品、饮料责任条款（可选）',
      clauseCodes: ['GP8022122447225', 'GP8022119698930','GP8022103398399']
    }
  }
}

// 鼎和1、2个月不支持整单退保产品
export const DINGHE_PRODUCRCT_IDS = [
  '80190',
]

// 有些产品会下架一些险种，后续不再售了，但是老产品的订单维度还是需要展示用户之前投保的
export const DEPRECATED_CLAUSES_IDS = {
  80156: ['006', '007', '008'],
}


// WEBPACK FOOTER //
// ./src/util/GLOBAL.js